export default "__VITE_ASSET__CISQsiml__"